module.exports = __webpack_public_path__ + "img/wine-glass-alt.85863a91.svg";